module.exports = __webpack_public_path__ + "img/weba.ca4fef43.svg";